import React from 'react';
import { ShippingBanner } from '../components/ShippingBanner';
import { Navbar } from '../components/Navbar';
import { HeroBanner } from '../components/HeroBanner';
import { CategoryHighlights } from '../components/CategoryHighlights';
import { FeaturedProducts } from '../components/FeaturedProducts';
import { InstagramBanner } from '../components/InstagramBanner';
import { Footer } from '../components/Footer';
export function HomePage() {
  return <div className="min-h-screen flex flex-col bg-[#FDF8F3]" data-id="element-895">
      <ShippingBanner data-id="element-896" />
      <Navbar data-id="element-897" />
      <main className="flex-grow" data-id="element-898">
        <HeroBanner data-id="element-899" />
        <CategoryHighlights data-id="element-900" />
        <FeaturedProducts data-id="element-901" />
        <InstagramBanner data-id="element-902" />
      </main>
      <Footer data-id="element-903" />
    </div>;
}